<script lang="ts">
	import { BehaviorSubject, debounceTime, filter, tap } from "rxjs";
	import { createEventDispatcher, onDestroy } from "svelte";
	import { fly } from "svelte/transition";
  import ToolTip, { ToolPosition } from "./ToolTip.svelte";
  import {truthy} from "$lib/util/func";

	export let quantity = 0;
	export let min = 0;
	export let max = 999;
	export let step = 1;
	export let debounce = true;

	const dispatch = createEventDispatcher();

	let loading = false;
	$: showMaxMsg = quantity === max;

  const qty$ = new BehaviorSubject(quantity);
	$: {
    qty$.next(quantity);
    loading = false;
    if (max === 0) max = 999;
  }

  const qtySub = qty$.pipe(
    filter(qty => qty !== quantity),
    tap(() => { loading = true; }),
    debounceTime(50),
  ).subscribe(qty => {
		if (qty >= max) showMaxMsg = true;
    if (qty <= max) dispatch('update', qty);
  });

  onDestroy(() => {
    qtySub.unsubscribe();
  });
</script>

{#if truthy($qty$) && debounce }
	<div class="quantity" class:active={$qty$} class:loading={loading} data-testid="quantity-picker">
		{#if showMaxMsg}
			<!-- <div class="label-s book max" in:fly|global="{{ y: 8, duration: 200 }}" out:fly|global="{{ y: -8, duration: 200 }}">
				Max item limit {max}
			</div> -->
			<ToolTip message={`Max item limit ${max}`} pos={ToolPosition.TC} />
		{/if}
		{#if $qty$}
				<button on:click={(e) => {e.stopPropagation();$qty$ > min ? qty$.next($qty$ - step) : 0}} disabled={$qty$ === min} data-testid="decrement">
					{#if $qty$ > 1}
						<span class="icon-minus-28"></span>
					{:else}
						<span class="icon-trash-20"></span>
					{/if}
				</button>
			<span class="headline-s bold count" data-testid="quantity-label">{ $qty$ }</span>
		{/if}
		<button on:click={(e) => {e.stopPropagation();$qty$ < max ? qty$.next($qty$ + step) : 0}} disabled={$qty$ === max} data-testid="increment">
			{#if $qty$ === 0}<span class="body-l bold add"><span>Add</span></span>{/if}<span class="icon-add-28 vertical-middle"></span>
		</button>
	</div>
{:else if !debounce}
	<div class="quantity" class:active={quantity} data-testid="quantity-picker">
		{#if quantity === max}
			<!-- <div class="label-s book max" in:fly|global="{{ y: 8, duration: 200 }}" out:fly|global="{{ y: -8, duration: 200 }}">
				Max item limit {max}
			</div> -->
			<ToolTip message={`Max item limit ${max}`} pos={ToolPosition.TC} />
		{/if}
		{#if quantity}
				<!-- disabled={quantity === 1} -->
				<button  on:click={(e) => { e.stopPropagation(); quantity -= step}} disabled={quantity === min} data-testid="decrement">
					{#if quantity > 1}
						<span class="icon-minus-28"></span>
					{:else}
						<span class="icon-trash-20"></span>
					{/if}
				</button>
			<span class="headline-s bold count" data-testid="quantity-label">{ quantity }</span>
		{/if}
		<button on:click={(e) => {e.stopPropagation(); quantity += step}} disabled={quantity === max} data-testid="increment">
			{#if quantity === 0}<span class="body-l bold add"><span>Add</span></span>{/if}<span class="icon-add-28 vertical-middle"></span>
		</button>
	</div>
{/if}
